module.exports = __webpack_public_path__ + "img/success-image.8f947246.svg";